import {RouteEntry} from "../../shared/routes";
import {Photos} from "./Photos";

export const photosRoutes: Array<RouteEntry> = [
    { path: '/photos/:id', component: Photos },
    { path: '/photos', component: Photos },
];
